export class FinancialYearMonthRequest  {
  LoginToken: string = '';
  TransactionType: number = 0;
}

